export default __webpack_public_path__ + "static/media/1655.0b3588ea.png";